import script from "./MaiALauncher.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaiALauncher.vue?vue&type=script&setup=true&lang=ts"

import "./MaiALauncher.vue?vue&type=style&index=0&id=3ff40312&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff40312"]])

export default __exports__